import React, { useLayoutEffect } from "react";
import { useEffect, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Hero from "../hero/hero";
import About from "../about/about";
import Contact from '../contact/contact'
import Amenities from "../amenities/amenities";
import Highlight from "../highlights/highlights";
import Highlights from "../highlights/highlights";
import ContactPopup from "../contactPopup/contactPopup";
import Rera from "../rera/rera"

gsap.registerPlugin(ScrollTrigger);

const Home = () => {
const [popupOpen, setPopupOpen] = useState(false);
const [popupPos, setPopupPos] = useState({ x: 0, y: 0 });
const openPopup = (e) => {
  setPopupPos({
    x: e.clientX,
    y: e.clientY,
  });

  setPopupOpen(true);
};

  useLayoutEffect(() => {

    const ctx = gsap.context(() => {

      // animate ONLY simple sections (not GSAP-heavy components)
      const sections = gsap.utils.toArray(".fade-section");

      sections.forEach((el) => {
        gsap.fromTo(
          el,
          {
            opacity: 0,
            y: 60,
          },
          {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: el,
              start: "top 85%",
              toggleActions: "play none none reverse",
              invalidateOnRefresh: true,
            },
          }
        );
      });

    });

    return () => ctx.revert();

  }, []);

  return (
    <>
      {/* HERO */}
      <div className="fade-section">
        <Hero />
      </div>

      {/* ABOUT (HAS ITS OWN GSAP SCROLL INSIDE IT) */}
      <div className="fade-section">
        <About />
      </div>
      <div className="fade-section">
        <Amenities />
      </div>
      <div className="fade-section">
        <Highlights />
      </div>
      <div className="fade-section">
        <Contact />
      </div>
      <div className="fade-section">
        <Rera />
      </div>
    </>
  );
};

export default Home;